<template>
  <section class="listing">
    <div class="header">
      <div class="title">Dashboard</div>
    </div>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading">
        <div class="filter">
          <form action="" class="form">
            <label class="dash-text">Tipo de venda</label>
            <select v-model="sellType" @change="getType" style="width:300px;">
              <option :value="'all'">Geral</option>
              <option :value="'online'">Online</option>
              <option :value="'bilheteria'">Bilheteria</option>
            </select>
          </form>
          <form action="" class="form">
            <label>Período</label>
            <div style="display:flex;">
              <div @click="get1Day" class="button-dash" :class="{ 'dash-active' : filter === '1D' }">1D</div>
              <div @click="get1Week" class="button-dash" :class="{ 'dash-active' : filter === '1S' }">1S</div>
              <div @click="get1Month" class="button-dash" :class="{ 'dash-active' : filter === '1M' }">1M</div>
              <div @click="get3Month" class="button-dash" :class="{ 'dash-active' : filter === '3M' }">3M</div>
              <div @click="get6Month" class="button-dash" :class="{ 'dash-active' : filter === '6M' }">6M</div>
              <div @click="get1Year" class="button-dash" :class="{ 'dash-active' : filter === '1A' }">1A</div>
            </div>
          </form>
          <form @submit.prevent class="form">
            <label>Personalizado</label>
            <div style="display:flex;">
              <label class="switch" title="Comparação personalizada" style="margin-top:10px;">
                <input v-model="custom" type="checkbox">
                <span class="slider"></span>
              </label>
              <date-picker v-if="custom" v-model="periodIni" type="date" range placeholder="Selecione o período inicial" format="DD/MM/YYYY"></date-picker>
              <date-picker v-if="custom" v-model="periodEnd" type="date" range placeholder="Selecione o período final" format="DD/MM/YYYY" style="margin-left:10px;"></date-picker>
              <button type="button" v-if="custom && periodIni && periodEnd" @click="getCustomData" class="button-save"><i class="fas fa-check"></i><span>Consultar</span></button>
            </div>
          </form>
        </div>
        <div class="dash-previous">{{ atualDash }}</div>
        <div class="dashboard">
          <div class="dash-item dash-item-big">
            <div class="dash-text">Resultado</div>
            <div class="dash-value">
              {{ result.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}
              <span :class="result >= resultPrev ? 'dash-up' : 'dash-down'">
                <i class="fas" :class="result >= resultPrev ? 'fa-long-arrow-alt-up' : 'fa-long-arrow-alt-down'"></i>
              </span>
            </div>
          </div>
          <div class="dash-item">
            <div class="dash-text">Receitas</div>
            <div class="dash-value">
              {{ revenue.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}
              <span :class="revenue >= revenuePrev ? 'dash-up' : 'dash-down'">
                <i class="fas" :class="revenue >= revenuePrev ? 'fa-long-arrow-alt-up' : 'fa-long-arrow-alt-down'"></i>
              </span>
            </div>
          </div>
          <div class="dash-item">
            <div class="dash-text">Despesas</div>
            <div class="dash-value dash-expense">
              ({{ expenses.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }})
              <span :class="expenses >= expensesPrev ? 'dash-up' : 'dash-down'">
                <i class="fas" :class="expenses >= expensesPrev ? 'fa-long-arrow-alt-up' : 'fa-long-arrow-alt-down'"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="dashboard">
          <div class="dash-item dash-item-big">
            <div class="dash-text">Eventos</div>
            <div class="dash-value">
              {{ shows }}
              <span :class="shows >= showsPrev ? 'dash-up' : 'dash-down'">
                <i class="fas" :class="shows >= showsPrev ? 'fa-long-arrow-alt-up' : 'fa-long-arrow-alt-down'"></i>
              </span>
            </div>
          </div>
          <div class="dash-item">
            <div class="dash-text">Vendidos</div>
            <div class="dash-value">
              {{ tickets }}
              <span :class="tickets >= ticketsPrev ? 'dash-up' : 'dash-down'">
                <i class="fas" :class="tickets >= ticketsPrev ? 'fa-long-arrow-alt-up' : 'fa-long-arrow-alt-down'"></i>
              </span>
            </div>
          </div>
          <div class="dash-item">
            <div class="dash-text">Vacância</div>
            <div class="dash-value">
              {{ vacancy.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} %
              <span :class="vacancy >= vacancyPrev ? 'dash-up' : 'dash-down'">
                <i class="fas" :class="vacancy >= vacancyPrev ? 'fa-long-arrow-alt-up' : 'fa-long-arrow-alt-down'"></i>
              </span>
            </div>
          </div>
          <div class="dash-item">
            <div class="dash-text">Validados</div>
            <div class="dash-value">
              {{ validated }}
              <span :class="validated >= validatedPrev ? 'dash-up' : 'dash-down'">
                <i class="fas" :class="validated >= validatedPrev ? 'fa-long-arrow-alt-up' : 'fa-long-arrow-alt-down'"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="dash-previous">{{ previousDash }}</div>
        <div class="dashboard dashboard-prev">
          <div class="dash-item dash-item-big">
            <div class="dash-text">Resultado</div>
            <div class="dash-value">{{ resultPrev.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
          </div>
          <div class="dash-item">
            <div class="dash-text">Receitas</div>
            <div class="dash-value">{{ revenuePrev.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
          </div>
          <div class="dash-item">
            <div class="dash-text">Despesas</div>
            <div class="dash-value dash-expense">({{ expensesPrev.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }})</div>
          </div>
        </div>
        <div class="dashboard dashboard-prev">
          <div class="dash-item dash-item-big">
            <div class="dash-text">Eventos</div>
            <div class="dash-value">{{ showsPrev }}</div>
          </div>
          <div class="dash-item">
            <div class="dash-text">Vendidos</div>
            <div class="dash-value">{{ ticketsPrev }}</div>
          </div>
          <div class="dash-item">
            <div class="dash-text">Vacância</div>
            <div class="dash-value">{{ vacancyPrev.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} %</div>
          </div>
          <div class="dash-item">
            <div class="dash-text">Validados</div>
            <div class="dash-value">
              {{ validated }}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import logger from '../../logger'
import { getData } from '../api/dashboard'

export default {
  name: 'dashboard',
  data () {
    return {
      loading: true,
      custom: false,
      periodIni: null,
      periodEnd: null,
      sellType: 'all',
      filter: '1S',
      result: 0,
      revenue: 0,
      expenses: 0,
      shows: 0,
      tickets: 0,
      vacancy: 0,
      validated: 0,
      atualDash: 'Hoje',
      previousDash: 'Ontem',
      resultPrev: 0,
      revenuePrev: 0,
      expensesPrev: 0,
      showsPrev: 0,
      ticketsPrev: 0,
      vacancyPrev: 0,
      validatedPrev: 0
    }
  },
  async mounted () {
    this.get1Week()
  },
  methods: {
    async get1Day () {
      this.loading = true
      this.custom = false
      this.filter = '1D'
      this.atualDash = 'Hoje'
      this.previousDash = 'Ontem'
      const iniDate = new Date()
      iniDate.setUTCHours(0, 0, 0, 0)
      // iniDate.setDate(iniDate.getDate())
      const endDate = new Date()
      endDate.setUTCHours(0, 0, 0, 0)
      // endDate.setDate(endDate.getDate())
      await this.getData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      iniDate.setUTCDate(iniDate.getUTCDate() - 1)
      endDate.setUTCDate(endDate.getUTCDate() - 1)
      await this.getPreviousData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      this.loading = false
    },
    async get1Week () {
      this.loading = true
      this.custom = false
      this.filter = '1S'
      this.atualDash = 'Semana Atual'
      this.previousDash = 'Semana Anterior'
      const iniDate = new Date()
      iniDate.setUTCHours(0, 0, 0, 0)
      iniDate.setUTCDate(iniDate.getUTCDate() - iniDate.getUTCDay())
      const endDate = new Date()
      endDate.setUTCHours(0, 0, 0, 0)
      endDate.setUTCDate(endDate.getUTCDate() + 6 - endDate.getUTCDay())
      this.atualDash += ' (' + this.formatUTCDate(iniDate) + ' - ' + this.formatUTCDate(endDate) + ')'
      await this.getData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      iniDate.setUTCDate(iniDate.getUTCDate() - 7)
      endDate.setUTCDate(endDate.getUTCDate() - 7)
      this.previousDash += ' (' + this.formatUTCDate(iniDate) + ' - ' + this.formatUTCDate(endDate) + ')'
      await this.getPreviousData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      this.loading = false
    },
    async get1Month () {
      this.loading = true
      this.custom = false
      this.filter = '1M'
      this.atualDash = 'Mês Atual'
      this.previousDash = 'Mês Anterior'
      let aux = new Date()
      let iniDate = new Date(aux.getUTCFullYear(), aux.getUTCMonth(), 1)
      iniDate.setUTCHours(0, 0, 0, 0)
      let endDate = new Date(aux.getUTCFullYear(), aux.getUTCMonth() + 1, 0)
      endDate.setUTCHours(0, 0, 0, 0)
      this.atualDash += ' (' + this.formatUTCDate(iniDate) + ' - ' + this.formatUTCDate(endDate) + ')'
      await this.getData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      aux.setUTCDate(iniDate.getUTCDate() - 30)
      iniDate = new Date(aux.getUTCFullYear(), aux.getUTCMonth(), 1)
      endDate = new Date(aux.getUTCFullYear(), aux.getUTCMonth() + 1, 0)
      this.previousDash += ' (' + this.formatUTCDate(iniDate) + ' - ' + this.formatUTCDate(endDate) + ')'
      await this.getPreviousData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      this.loading = false
    },
    async get3Month () {
      this.loading = true
      this.custom = false
      this.filter = '3M'
      this.atualDash = 'Trimestre atual'
      this.previousDash = 'Trimestre anterior'
      let aux = this.getDatesQuarter(new Date())
      let iniDate = aux[0]
      iniDate.setUTCHours(0, 0, 0, 0)
      let endDate = aux[1]
      endDate.setUTCHours(0, 0, 0, 0)
      this.atualDash += ' (' + this.formatUTCDate(iniDate) + ' - ' + this.formatUTCDate(endDate) + ')'
      await this.getData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      const auxDate = new Date()
      auxDate.setUTCDate(auxDate.getUTCDate() - 90)
      aux = this.getDatesQuarter(auxDate)
      iniDate = aux[0]
      endDate = aux[1]
      this.previousDash += ' (' + this.formatUTCDate(iniDate) + ' - ' + this.formatUTCDate(endDate) + ')'
      await this.getPreviousData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      this.loading = false
    },
    async get6Month () {
      this.loading = true
      this.custom = false
      this.filter = '6M'
      this.atualDash = 'Semestre atual'
      this.previousDash = 'Semestre anterior'
      let aux = this.getDatesHalfYear(new Date())
      let iniDate = aux[0]
      iniDate.setUTCHours(0, 0, 0, 0)
      let endDate = aux[1]
      endDate.setUTCHours(0, 0, 0, 0)
      this.atualDash += ' (' + this.formatUTCDate(iniDate) + ' - ' + this.formatUTCDate(endDate) + ')'
      await this.getData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      const auxDate = new Date()
      auxDate.setUTCDate(auxDate.getUTCDate() - 180)
      aux = this.getDatesHalfYear(auxDate)
      iniDate = aux[0]
      endDate = aux[1]
      this.previousDash += ' (' + this.formatUTCDate(iniDate) + ' - ' + this.formatUTCDate(endDate) + ')'
      await this.getPreviousData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      this.loading = false
    },
    async get1Year () {
      this.loading = true
      this.custom = false
      this.filter = '1A'
      this.atualDash = 'Ano atual'
      this.previousDash = 'Ano anterior'
      const aux = new Date()
      let iniDate = new Date(aux.getFullYear(), 0, 1)
      iniDate.setUTCHours(0, 0, 0, 0)
      let endDate = new Date(aux.getFullYear(), 11, 31)
      endDate.setUTCHours(0, 0, 0, 0)
      this.atualDash += ' (' + this.formatUTCDate(iniDate) + ' - ' + this.formatUTCDate(endDate) + ')'
      await this.getData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      aux.setDate(aux.getDate() - 365)
      iniDate = new Date(aux.getFullYear(), 0, 1)
      endDate = new Date(aux.getFullYear(), 11, 31)
      this.previousDash += ' (' + this.formatUTCDate(iniDate) + ' - ' + this.formatUTCDate(endDate) + ')'
      await this.getPreviousData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      this.loading = false
    },
    async getCustomData () {
      this.loading = true
      this.atualDash = 'Período inicial'
      this.previousDash = 'Período final'
      let iniDate = new Date(this.periodIni[0])
      iniDate.setUTCHours(0, 0, 0, 0)
      let endDate = new Date(this.periodIni[1])
      endDate.setUTCHours(0, 0, 0, 0)
      this.atualDash += ' (' + this.formatUTCDate(iniDate) + ' - ' + this.formatUTCDate(endDate) + ')'
      await this.getData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      iniDate = new Date(this.periodEnd[0])
      endDate = new Date(this.periodEnd[1])
      this.previousDash += ' (' + this.formatUTCDate(iniDate) + ' - ' + this.formatUTCDate(endDate) + ')'
      await this.getPreviousData(iniDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
      this.loading = false
    },
    async getType () {
      if (this.custom) {
        this.getCustomData()
      } else {
        if (this.filter === '1D') this.get1Day()
        if (this.filter === '1S') this.get1Week()
        if (this.filter === '1M') this.get1Month()
        if (this.filter === '3M') this.get3Month()
        if (this.filter === '6M') this.get6Month()
        if (this.filter === '1A') this.get1Year()
      }
    },
    async getData (iniDate, endDate) {
      try {
        const { business, data } = await getData(iniDate, endDate, this.sellType)
        if (data.length > 0) {
          this.revenue = data.map(x => Number(x.revenue)).reduce((acc, cur) => acc + cur)
          this.expenses = data.map(x =>
            Number(x.expensesPayment ? x.expensesPayment : 0) +
            Number(x.expensesPrint ? x.expensesPrint : 0) +
            Number(x.expensesExtra ? x.expensesExtra : 0)
          ).reduce((acc, cur) => acc + cur)
          this.result = this.revenue - this.expenses
          this.shows = data.length
          this.tickets = data.map(x => Number(x.tickets)).reduce((acc, cur) => acc + cur)
          this.vacancy = (this.tickets / (business.capacity * this.shows)) * 100
          this.validated = data.map(x => Number(x.validated)).reduce((acc, cur) => acc + cur)
        } else {
          this.revenue = 0
          this.expenses = 0
          this.result = 0
          this.shows = 0
          this.tickets = 0
          this.vacancy = 0
          this.validated = 0
        }
      } catch (error) {
        logger.error(error, this)
        this.loading = false
      }
    },
    async getPreviousData (iniDate, endDate) {
      try {
        const { business, data } = await getData(iniDate, endDate, this.sellType)
        if (data.length > 0) {
          this.revenuePrev = data.map(x => Number(x.revenue)).reduce((acc, cur) => acc + cur)
          this.expensesPrev = data.map(x =>
            Number(x.expensesPayment ? x.expensesPayment : 0) +
            Number(x.expensesPrint ? x.expensesPrint : 0) +
            Number(x.expensesExtra ? x.expensesExtra : 0)
          ).reduce((acc, cur) => acc + cur)
          this.resultPrev = this.revenuePrev - this.expensesPrev
          this.showsPrev = data.length
          this.ticketsPrev = data.map(x => Number(x.tickets)).reduce((acc, cur) => acc + cur)
          this.vacancyPrev = (this.ticketsPrev / (business.capacity * this.showsPrev)) * 100
          this.validatedPrev = data.map(x => Number(x.validated)).reduce((acc, cur) => acc + cur)
        } else {
          this.revenuePrev = 0
          this.expensesPrev = 0
          this.resultPrev = 0
          this.showsPrev = 0
          this.ticketsPrev = 0
          this.vacancyPrev = 0
          this.validatedPrev = 0
        }
      } catch (error) {
        logger.error(error, this)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.button-save {
  height: 35px;
  margin-left: 20px;
}
.filter {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  .form {
    padding: 0 10px 5px 0;
    width: 100%;
  }
}
.button-dash {
  width: 30px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  border: 1px solid $primary-color;
  border-radius: 5px;
  color: $primary-color;
  font-size: 0.8rem;
  margin: 8px 2px;
  cursor: pointer;

  &:hover {
    background-color: $hover-color;
  }

  &.dash-active {
    color: #fff;
    background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  }
}

.dashboard {
  margin: 30px 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;

  .dash-item {
    margin: 10px 5px;
    min-width: 220px;
  }

  .dash-item-big {
    .dash-text {
      font-size: 1.6em !important;
    }
    .dash-value {
      font-size: 3em !important;
      color: $secondary-color !important;
    }
  }

  .dash-text {
    font-size: 1em;
    font-weight: 400;
    color: #777;
    text-transform: uppercase;
  }

  .dash-value {
    font-size: 2em;
    font-weight: 400;
    color: $primary-color;

    span {
      font-size: 0.5em;
      font-weight: 300;
      color: #999;
    }

    .dash-up {
      color: rgb(0, 110, 0);
    }

    .dash-down {
      color: rgb(200, 0, 0);
    }
  }

  .dash-expense {
    color: rgb(130, 0, 0) !important;
  }
}

.dash-previous {
  border-top: 1px dashed #ccc;
  margin: 20px 0;
  font-size: 1.3rem;
  font-weight: 300;
  color: #777;
  text-align: center;
  text-transform: uppercase;
  padding-top: 10px;
}

.dashboard-prev {
  .dash-value {
    color: #555 !important;
  }
  .dash-item-big {
    .dash-text {
      font-size: 1.6em !important;
    }
    .dash-value {
      font-size: 3em !important;
      color: #555 !important;
    }
  }
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .dashboard {
    justify-content: space-around;
  }
  .form {
    width: auto !important;
    padding: 0 30px 5px 0 !important;
  }
}
</style>
